import type { PlanKey } from "./account-client";

const ADMIN_REQUEST_TIMEOUT_MS = 15_000;

export interface AdminOverview {
  generatedAt: string;
  totals: {
    users: number;
    workspaces: number;
    projects: number;
    liveApps: number;
    paidWorkspaces: number;
  };
  plans: Record<PlanKey, number>;
  recentUsers: Array<{
    id: string;
    name: string;
    email: string;
    createdAt: string;
  }>;
  recentProjects: Array<{
    id: string;
    name: string;
    url: string;
    status: "draft" | "live" | "offline";
    workspace: string;
    plan: PlanKey;
    createdAt: string;
  }>;
}

export async function loadAdminOverview(): Promise<AdminOverview> {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => { controller.abort(); }, ADMIN_REQUEST_TIMEOUT_MS);
  try {
    const response = await fetch("/api/admin/v1/overview", {
      credentials: "same-origin",
      headers: { accept: "application/json" },
      signal: controller.signal,
    });
    const body = await response.json().catch(() => ({})) as Partial<AdminOverview> & { message?: string };
    if (!response.ok) {
      throw new Error(body.message ?? "Doorway could not load the admin dashboard.");
    }
    return body as AdminOverview;
  } catch (error) {
    if (controller.signal.aborted) {
      throw new Error("Doorway took too long to load the admin dashboard. Try again.");
    }
    throw error;
  } finally {
    window.clearTimeout(timeout);
  }
}
